import {MetaMaskConnector} from '@wagmi/core/connectors/metaMask';
import {connect} from '@wagmi/core';
import {CustomObservableError} from '@/streams/utils';
import {chains, connectChainId} from '../shared';
import {disconnect} from './disconnect';
import {watchAutoConnect} from './connector';
import {envUtil} from '@/helper';

export const metaMaskConnector = new MetaMaskConnector({
  chains,
  options: {
    UNSTABLE_shimOnConnectSelectAccount: true,
  },
});

/**
 * 连接MetaMask
 */
export async function connectMetaMaskWallet(params?: ConnectParams) {
  const {useCurrentChain = false} = params || {};
  try {
    // TODO: 断开，让用户重新选择账户
    await disconnect();
    const params = useCurrentChain ? {} : {chainId: connectChainId};
    await connect({connector: metaMaskConnector, ...params});
  } catch (error) {
    console.log(error.details);
    // 未安装或者禁用metamask
    if (error?.name === 'ConnectorNotFoundError' && !envUtil.isMobile) {
      window.open('https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn', '_blank', 'noopener');
      throw new CustomObservableError(error.message);
    }
    // 已经有请求窗口在进行中
    if ((error?.details || '').includes('Already processing eth_requestAccounts')) {
      throw new Error('The wallet has an ongoing connection request, please locate the wallet window and then proceed.');
    }
    // 自主取消连接
    if ([4001].includes(error?.code)) {
      throw new CustomObservableError(error.message);
    }
    throw error;
  }

  // 监听自动连接
  const {promise: autoConnectedPromise, subscription: autoConnectedSubscription} = watchAutoConnect();

  try {
    const data = await autoConnectedPromise;
    autoConnectedSubscription.unsubscribe();
    return data;
  } catch (error) {
    autoConnectedSubscription.unsubscribe();
    throw error;
  }
}

interface ConnectParams {
  /**
   * 是否使用当前钱包链接的链：如果不使用，则会使用主网链接
   */
  useCurrentChain?: boolean;
}
